/**
 * Referral admin API
 *
 * Reward-day configuration for the friend-referral marketing feature.
 * Endpoints are admin-only under the `/v1/admin` prefix (auto-added by apiClient).
 */

import { apiClient } from './client';

export interface ReferralConfig {
  referrer_days_on_signup: number;
  referrer_days_on_first_purchase: number;
  referee_days_on_signup: number;
}

export const referralApi = {
  async getConfig(): Promise<ReferralConfig> {
    const { data } = await apiClient.get<ReferralConfig>('/referral/config');
    return data;
  },

  async updateConfig(payload: ReferralConfig): Promise<ReferralConfig> {
    const { data } = await apiClient.put<ReferralConfig>('/referral/config', payload);
    return data;
  },
};
